import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { 
  Mic, 
  Plus, 
  Upload, 
  Link, 
  ArrowRight, 
  XCircle,
  Sparkles,
  Filter,
  Edit2,
  Clock
} from 'lucide-react';

export const QueriesHelpDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-slate-900">
            Ayuda - Consultas
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6 py-4">
          <div>
            <h3 className="font-semibold text-slate-900 mb-2">¿Que son las consultas?</h3>
            <p className="text-sm text-slate-600">
              Las consultas son solicitudes o dudas que el personal (staff) puede enviar a direccion. 
              Direccion puede convertirlas en tareas formales o rechazarlas.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900 mb-3">Como crear una consulta</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3 bg-stone-50 p-3 rounded-lg">
                <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <Mic className="w-4 h-4 text-emerald-600" />
                </div>
                <div>
                  <p className="font-medium text-slate-900 text-sm">Por voz</p>
                  <p className="text-xs text-slate-500">
                    Pulsa el boton verde del microfono, habla tu consulta, y el sistema 
                    transcribira y rellenara automaticamente el titulo y descripcion.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-stone-50 p-3 rounded-lg">
                <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0">
                  <Plus className="w-4 h-4 text-slate-600" />
                </div>
                <div>
                  <p className="font-medium text-slate-900 text-sm">Manual</p>
                  <p className="text-xs text-slate-500">
                    Escribe directamente el titulo y la descripcion de tu consulta.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-stone-50 p-3 rounded-lg">
                <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                  <Upload className="w-4 h-4 text-blue-600" />
                </div>
                <div>
                  <p className="font-medium text-slate-900 text-sm">Adjuntar archivos</p>
                  <p className="text-xs text-slate-500">
                    Puedes adjuntar imagenes, PDFs o documentos, y agregar enlaces relacionados.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900 mb-3">Estados de una consulta</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <span className="px-2 py-1 bg-amber-100 text-amber-700 text-xs font-bold rounded">PENDIENTE</span>
                <span className="text-sm text-slate-600">Esperando revision de direccion</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="px-2 py-1 bg-emerald-100 text-emerald-700 text-xs font-bold rounded">CONVERTIDA</span>
                <span className="text-sm text-slate-600">Se ha creado una tarea a partir de esta consulta</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="px-2 py-1 bg-slate-100 text-slate-500 text-xs font-bold rounded">RECHAZADA</span>
                <span className="text-sm text-slate-600">No procede crear una tarea</span>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const TasksHelpDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-slate-900">
            Ayuda - Tareas
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6 py-4">
          <div>
            <h3 className="font-semibold text-slate-900 mb-2">¿Que son las tareas?</h3>
            <p className="text-sm text-slate-600">
              Las tareas son actividades o trabajos a realizar en el club. Tienen un numero 
              secuencial unico (ej: 2026001), prioridad, estado y pueden asignarse a agentes.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900 mb-3">Como crear una tarea</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3 bg-stone-50 p-3 rounded-lg">
                <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <Mic className="w-4 h-4 text-emerald-600" />
                </div>
                <div>
                  <p className="font-medium text-slate-900 text-sm">Voz a Tarea</p>
                  <p className="text-xs text-slate-500">
                    Usa el boton "Voz a Tarea" en el menu lateral. Graba tu descripcion y la IA 
                    extraera automaticamente: titulo, descripcion, area funcional y prioridad.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-stone-50 p-3 rounded-lg">
                <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                  <Sparkles className="w-4 h-4 text-blue-600" />
                </div>
                <div>
                  <p className="font-medium text-slate-900 text-sm">Analisis con IA</p>
                  <p className="text-xs text-slate-500">
                    Al crear una tarea manualmente, escribe la descripcion y pulsa "Analizar con IA" 
                    para que sugiera el titulo, area y prioridad automaticamente.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-stone-50 p-3 rounded-lg">
                <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
                  <ArrowRight className="w-4 h-4 text-amber-600" />
                </div>
                <div>
                  <p className="font-medium text-slate-900 text-sm">Desde una consulta</p>
                  <p className="text-xs text-slate-500">
                    Puedes convertir una consulta pendiente en tarea usando el boton "Convertir".
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900 mb-3">Prioridades</h3>
            <div className="grid grid-cols-2 gap-2">
              <span className="px-2 py-1 bg-red-100 text-red-700 text-xs font-bold rounded text-center">URGENTE</span>
              <span className="px-2 py-1 bg-orange-100 text-orange-700 text-xs font-bold rounded text-center">ALTA</span>
              <span className="px-2 py-1 bg-amber-100 text-amber-700 text-xs font-bold rounded text-center">MEDIA-ALTA</span>
              <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs font-bold rounded text-center">MEDIA</span>
              <span className="px-2 py-1 bg-slate-100 text-slate-700 text-xs font-bold rounded text-center">MEDIA-BAJA</span>
              <span className="px-2 py-1 bg-stone-100 text-stone-600 text-xs font-bold rounded text-center">BAJA</span>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900 mb-3">Estados de una tarea</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <span className="px-2 py-1 bg-amber-100 text-amber-700 text-xs font-bold rounded">PENDIENTE</span>
                <span className="text-sm text-slate-600">Sin iniciar</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs font-bold rounded">EN PROCESO</span>
                <span className="text-sm text-slate-600">Trabajo en curso</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="px-2 py-1 bg-emerald-100 text-emerald-700 text-xs font-bold rounded">COMPLETADA</span>
                <span className="text-sm text-slate-600">Finalizada</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="px-2 py-1 bg-red-100 text-red-700 text-xs font-bold rounded">BLOQUEADA</span>
                <span className="text-sm text-slate-600">Detenida por algun impedimento</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="px-2 py-1 bg-slate-100 text-slate-500 text-xs font-bold rounded">CANCELADA</span>
                <span className="text-sm text-slate-600">No se realizara</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900 mb-3">Filtros y busqueda</h3>
            <div className="flex items-start gap-3 bg-stone-50 p-3 rounded-lg">
              <Filter className="w-5 h-5 text-slate-600 flex-shrink-0 mt-0.5" />
              <p className="text-xs text-slate-500">
                Usa los filtros de area funcional, prioridad y estado para encontrar tareas. 
                Tambien puedes buscar por numero, titulo o descripcion.
              </p>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900 mb-3">Historial de pasos</h3>
            <div className="flex items-start gap-3 bg-stone-50 p-3 rounded-lg">
              <Clock className="w-5 h-5 text-slate-600 flex-shrink-0 mt-0.5" />
              <p className="text-xs text-slate-500">
                Cada tarea tiene un historial de pasos donde puedes registrar el progreso, 
                quien realizo cada accion y cuando.
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
